export function setToken(payload){
    return{
        type:'setToken',
        payload
    }
}